import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdFuelSavingComponent } from './ad-fuel-saving/ad-fuel-saving.component';
import { DigitalDisplayDirective } from './digital-display.directive';
import { AdTypicalUiComponent } from './ad-typical-ui/ad-typical-ui.component';

@NgModule({
  declarations: [
    AdFuelSavingComponent,
    DigitalDisplayDirective,
    AdTypicalUiComponent
  ],
  exports: [
    AdFuelSavingComponent,
    AdTypicalUiComponent
  ],
  imports: [
    CommonModule
  ]
})
export class AdsModule { }
